export default {
      id: "timer-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "sprite.svg#timer",
      toString: function () {
        return this.url;
      }
    }